export default __webpack_public_path__ + "static/media/background.60a1d768.jpg";